import gameIds from '../../hub/data/GameIds';

export const GAME_ID = gameIds.SUPER_MATCH;

export const NUM_LEVELS = 7;
export const ZAPS_TO_MASTER = 10;
